import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export type AppRole = "admin" | "customer" | "sales";

export const useUserRole = () => {
  const { user } = useAuth();

  const { data: roles, isLoading } = useQuery({
    queryKey: ["userRoles", user?.id],
    queryFn: async () => {
      if (!user?.id) return [];

      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id);

      if (error) throw error;
      return data.map((r) => r.role as AppRole);
    },
    enabled: !!user?.id,
  });

  const hasRole = (role: AppRole) => {
    return roles?.includes(role) ?? false;
  };

  const isAdmin = hasRole("admin");
  const isCustomer = hasRole("customer");
  const isSales = hasRole("sales");

  return {
    roles: roles ?? [],
    hasRole,
    isAdmin,
    isCustomer,
    isSales,
    isLoading,
  };
};
